<template>
    <div class="home">
        <div class="container">
            <center>
                <h3 style="color: #1ca836">
                    Consulta tutte le sentenze di merito
                </h3>
                <h4>
                    <b>
                        Le sentenze dei Tribunali e delle Corti d'Appello

                    </b>
                </h4>
                <h4>
                    <u>
                        Registrazione GRATUITA
                    </u>
                </h4>
                <h5>(Inserendo il codice fiscale)</h5>
                <p>Registrazione gratuita consentita ad Avvocati e operatori di giustizia per la consultazione senza
                    costi di tutte le sentenze dei Tribunali e delle Corti d'Appello. Se sei un operatore di giustizia
                    (magistrato, curatore, perito, etc.) e non ricevi la PEC dopo aver inserito il codice fiscale,
                    scrivi a admin@giustup.it. L'abbonamento Premium consente ricerca avanzata e funzioni di estrazione.
                </p>
                <iframe width="280" height="157" src="https://www.youtube.com/embed/rgJGt4dDESo"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <h3 class="h3" style="color: #1ca836">PROVA!</h3>
                <h4 style="color: #1ca836"> Non spendi niente e puoi consultare tutto </h4>
                PER VERIFICARE CHE TU SIA AVVOCATO O OPERATORE DI GIUSTIZIA INSERISCI IL TUO CODICE FISCALE<br>
            </center>

            <div style="padding-top: 3px;">
                <div class="row justify-content-center">
                    <div class="contents" style="text-align:center; max-width:555px">


                        <div class="input-group">

                            <input style="text-align:center;" type="text" class="form-control" id="txt_cod_fisc"
                                name="text_codfisc" aria-describedby="emailHelp" placeholder="CODICE FISCALE">
                            <div style="padding-left:0.5rem" class="input-group-btn">
                                <button class="btn btn-success" @click='registra()'>ACCEDI O REGISTRATI</button>
                                <!-- <button class="btn btn-success" @click='location.href="https://giustup.it/utente"'>vai a utente</button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <br>
        <!-- Cookie Solution-->
    </div>
</template>

<script>
import api from '../services/service.js';
import baseUrl from '../services/baseUrl.js';
import utils from '../services/utils.js';

export default {
    name: "home",

    async mounted() {
        if (await this.checkLogged())
            this.$router.replace({ name: "Search" });

        this.checkCookie();

        //se la pagina è caricata, nascondi l'elemento con id nav-collapse
        document.addEventListener("DOMContentLoaded", function (event) {
            document.getElementById("nav-collapse").style.display = "none !important;";
        });
    },

    methods: {
        // codice copypastato di nuovo
        registra() {
            if (this.ControllaCF(document.getElementById("txt_cod_fisc").value)) {
                var cod_fisc = document.getElementById("txt_cod_fisc").value.toUpperCase();
                utils.setCookie("cod_fisc", cod_fisc, 365);

                //send other URL params
                var params = window.location.search;
                if (params == "" || params === undefined)
                    params = "?utm_source=other";
                //send other URL params
                location.href = baseUrl.getBaseUrlFrontend() + params + "&codfisc=" + cod_fisc;
            }
            else {
                alert("Codice fiscale non valido!");
            }
        },
        ControllaCF(cf) {
            cf = cf.toUpperCase();
            if (cf == '') return false;
            if (! /^[0-9A-Z]{16}$/.test(cf))
                return false;
            var map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17,
                19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
            var s = 0;
            for (var i = 0; i < 15; i++) {
                var c = cf.charCodeAt(i);
                if (c < 65) {
                    c = c - 48;
                } else {
                    c = c - 55;
                }

                if (i % 2 == 0)
                    s += map[c];
                else
                    s += c < 10 ? c : c - 10;
            }
            var atteso = String.fromCharCode(65 + s % 26);
            if (atteso != cf.charAt(15))
                return false;
            return true;
        },

        checkCookie() {
            var user = utils.getCookie("cod_fisc");
            if (user != "") {
                document.getElementById("txt_cod_fisc").value = user;
            }
        },

        addScript(options) {
            const script = document.createElement("script");
            if (typeof options === "object")
                for (const option in options) {
                    script.setAttribute(
                        option,
                        options[option]
                    );
                }
            document.body.appendChild(script);
            return script;
        },

        async checkLogged() {
            let data = await api.execute('get', 'oauth');
            return data;
        }
    },
}

</script>


<style>
#app {
    /* NON CANCELLARE ALTRIMENTI NON FUNZIONA */
    /* per qualche motivo viene iniettato `display: none` dentro il template */
    display: block !important;
    height: 100vh;
}

footer {
    min-height: calc(30% + 2px);
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue